var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeInteriors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b,.c{stroke:#8b8c8c;}.b,.c,.e{stroke-miterlimit:10;}.b,.c,.d,.e{stroke-width:2.2px;}.c,.d,.e{fill:none;}.d,.e{stroke:#e8798a;}.e{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-466.136 -532.136)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 78,
    height: 78,
    transform: "translate(466.136 532.136)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(473.027 535.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 65.149,
    height: 27.363,
    transform: "translate(0 42.999)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 27.363,
    transform: "translate(44.302 42.999)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 27.363,
    transform: "translate(20.848 42.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H13.03V11.727H0Z",
    transform: "translate(26.06 53.423)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 2.606,
    transform: "translate(26.06 48.211)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 2.606,
    transform: "translate(31.272 48.211)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 2.606,
    transform: "translate(36.484 48.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M430.818,101v11.727L423,121.848v5.212h20.848v-5.212l-7.818-9.121V101",
    transform: "translate(-400.849 -101)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16.939,
    height: 11.727,
    transform: "translate(48.211 14.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16.939,
    height: 11.727,
    transform: "translate(0 14.333)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 20.848,
    transform: "translate(44.302 50.817)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 20.848,
    transform: "translate(0 52.12)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 20.848,
    transform: "translate(0 61.24)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInteriors);
export default __webpack_public_path__ + "static/media/homeInteriors.f502b2199d54979f50ecc82f1579f5d5.svg";
export { ForwardRef as ReactComponent };